// To do: Fix responsiveness of table and form
import { HStack, FormLabel, Input, useToast, Spacer } from "@chakra-ui/react";
import { useState } from "react";
import {
  convertGeocodeResultToGeoJSON,
  FeatureCollection,
} from "../../../components/mapcomponent/generic";
import PageComponent from "../../../components/PageComponent";
import ReverseGeocodeDocs from "../../../components/api-docs/ReverseGeocodeDocs";

export default function ReverseGeocode() {
  const [apiKey, setApiKey] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [results, setResults] = useState<{
    apiResponse: string;
    geoJSON: FeatureCollection;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleCopy = () => {
    results &&
      results.apiResponse &&
      navigator.clipboard.writeText(results.apiResponse);
    toast({
      title: "Success!",
      description: "API response successfully copied to your clipboard",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  async function handleSubmit() {
    try {
      setIsLoading(true);

      const response = await fetch(
        `${
          process.env.REACT_APP_V1_API_SERVER_ENDPOINT
        }/geocode/reverse?latlng=${[latitude, longitude].join(",")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": apiKey,
          },
        },
      );

      if (response.status === 401) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "Please provide a valid API key",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      if (response.status !== 200) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "There was an error fetching data",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const data = await response.json();
      console.log("Data:", data);
      if (data.results && data.results.length >= 1) {
        toast({
          title: "Success!",
          description: "Reverse geocode successfully completed",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "No results!",
          description: "Reverse geocode did not return any results.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      setResults({
        apiResponse: JSON.stringify(data, null, 2),
        geoJSON: convertGeocodeResultToGeoJSON(data.results),
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setResults(null);
      console.log(error);
      toast({
        title: "Error!",
        description: "There was an error fetching data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <PageComponent
      navItemsV1={[
        { title: "Reverse Geocode API", nav: "api" },
        { title: "Try out the API", nav: "playground" },
        { title: "API Documentation", nav: "documentation" },
        { title: "Base URL", nav: "baseurl" },
        { title: "Endpoint", nav: "endpoint" },
        { title: "Authentication", nav: "authentication" },
        { title: "Headers", nav: "headers" },
        { title: "Request Parameters", nav: "requestparameters" },
        { title: "Request Example", nav: "requestexamples" },
        { title: "Response Body", nav: "responsebody" },
        { title: "Response Field Reference", nav: "responsefields" },
        { title: "Example Requests", nav: "examplerequests" },
        { title: "Status Codes", nav: "statuscodes" },
        { title: "Notes", nav: "notes" },
      ]}
      handleCopy={handleCopy}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      isDisabled={!latitude || !longitude || !apiKey}
      result={results}
      documentationComponent={<ReverseGeocodeDocs />}
      formComponent={
        <>
          <HStack>
            <FormLabel pb={0} mb={0}>
              API Key
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter API key"
              borderColor={"#bcbcbc"}
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Latitude
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter latitude"
              borderColor={"#bcbcbc"}
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Longitude
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter longitude"
              borderColor={"#bcbcbc"}
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </HStack>
        </>
      }
      headerTitle={"Reverse Geocode"}
      headerPath={"v1/geocode/reverse"}
      headerDescription={
        "Convert geographic coordinates (latitude, longitude) into human-readable place and address information. Returns nearby places and address components ordered by relevance."
      }
    />
  );
}
